/** Zod validation schemas for Reorder endpoints */

import { z } from 'zod'

export const reorderItemsSchema = z.object({
  type: z.enum(['folder', 'document']),
  id: z.string(),
  parentId: z.string().nullable(),
  afterId: z.string().optional(),
  beforeId: z.string().optional(),
})
